import { render, staticRenderFns } from "./MobileFiltersButton.vue?vue&type=template&id=07ef5aae&scoped=true"
import script from "./MobileFiltersButton.vue?vue&type=script&lang=js"
export * from "./MobileFiltersButton.vue?vue&type=script&lang=js"
import style0 from "./MobileFiltersButton.vue?vue&type=style&index=0&id=07ef5aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ef5aae",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fmobile-filters-button%2FMobileFiltersButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports